// src/config.js
export const API_ADDRESS = window.location.hostname === 'valutix.io' || window.location.hostname === 'www.valutix.io'
  ? 'https://valutix.io/api/V1'
  : 'https://staging.valutix.io/api/V1';
